// Mock Data for ADK Creative Portfolio

export const portfolioProjects = [
  {
    id: 1,
    title: "Kafe Zero Marka Yenileme",
    category: "Kurumsal Kimlik",
    tags: ["Logo Tasarım", "Kurumsal Kimlik", "Menü Tasarım"],
    description: "Modern kahve kültürünü yansıtan minimalist marka kimliği tasarımı. Logo, menü ve sosyal medya görselleri ile tam paket çözüm.",
    image: "https://images.unsplash.com/photo-1495474472287-4d71bcdd2085?w=800&q=80",
    year: "2024",
    client: "Kafe Zero",
    featured: true,
    bgColor: "#1a1a1a"
  },
  {
    id: 2,
    title: "TechStart Logo ve Kimlik",
    category: "Logo Tasarım",
    tags: ["Logo Tasarım", "Kurumsal Kimlik"],
    description: "Teknoloji startup'ı için dinamik ve yenilikçi logo tasarımı. Modern geometrik formlarla profesyonel kimlik.",
    image: "https://images.unsplash.com/photo-1558655146-d09347e92766?w=800&q=80",
    year: "2024",
    client: "TechStart",
    featured: true,
    bgColor: "#0a0a0a"
  },
  {
    id: 3,
    title: "Organik Market Sosyal Medya",
    category: "Sosyal Medya Tasarımları",
    tags: ["Sosyal Medya Tasarımları", "İllüstrasyon"],
    description: "Organik ürünler markası için doğal ve samimi sosyal medya içerik tasarımları. Instagram feed konsepti.",
    image: "https://images.unsplash.com/photo-1488190211105-8b0e65b80b4e?w=800&q=80",
    year: "2024",
    client: "Organik Market",
    featured: false,
    bgColor: "#1a1a1a"
  },
  {
    id: 4,
    title: "Bartın Jazz Festivali Afişi",
    category: "Afiş / Poster Tasarım",
    tags: ["Afiş / Poster Tasarım"],
    description: "Bartın Jazz Festivali için dinamik ve ritmik poster tasarımı. Tipografi odaklı modern yaklaşım.",
    image: "https://images.unsplash.com/photo-1514320291840-2e0a9bf2a9ae?w=800&q=80",
    year: "2023",
    client: "Bartın Belediyesi",
    featured: true,
    bgColor: "#0a0a0a"
  },
  {
    id: 5,
    title: "Bella Restaurant Menü Tasarımı",
    category: "Menü / Baskı Tasarımları",
    tags: ["Menü / Baskı Tasarımları", "Kurumsal Kimlik"],
    description: "İtalyan restoranı için şık ve okunabilir menü tasarımı. Premium baskı malzemeleriyle uyumlu dizayn.",
    image: "https://images.unsplash.com/photo-1517248135467-4c7edcad34c4?w=800&q=80",
    year: "2024",
    client: "Bella Restaurant",
    featured: false,
    bgColor: "#1a1a1a"
  },
  {
    id: 6,
    title: "FitLife Spor Salonu Kimliği",
    category: "Kurumsal Kimlik",
    tags: ["Logo Tasarım", "Kurumsal Kimlik", "Sosyal Medya Tasarımları"],
    description: "Spor salonu için güçlü ve motivasyonel marka kimliği. Logo, kartvizit ve sosyal medya paket tasarım.",
    image: "https://images.unsplash.com/photo-1571902943202-507ec2618e8f?w=800&q=80",
    year: "2023",
    client: "FitLife Gym",
    featured: false,
    bgColor: "#0a0a0a"
  },
  {
    id: 7,
    title: "Urban Fashion Lookbook Tasarımı",
    category: "Afiş / Poster Tasarım",
    tags: ["Afiş / Poster Tasarım", "Sosyal Medya Tasarımları"],
    description: "Streetwear markası için cesur ve dinamik lookbook tasarımı. Editorial layout yaklaşımı.",
    image: "https://images.unsplash.com/photo-1483985988355-763728e1935b?w=800&q=80",
    year: "2024",
    client: "Urban Fashion",
    featured: true,
    bgColor: "#1a1a1a"
  },
  {
    id: 8,
    title: "Aromix Kozmetik Ambalaj",
    category: "Kurumsal Kimlik",
    tags: ["Kurumsal Kimlik", "Logo Tasarım"],
    description: "Doğal kozmetik markası için minimal ve şık ambalaj tasarımı. Sürdürülebilir tasarım anlayışı.",
    image: "https://images.unsplash.com/photo-1596462502278-27bfdc403348?w=800&q=80",
    year: "2023",
    client: "Aromix",
    featured: false,
    bgColor: "#0a0a0a"
  },
  {
    id: 9,
    title: "Dijital Zirve Konferans Afişi",
    category: "Afiş / Poster Tasarım",
    tags: ["Afiş / Poster Tasarım"],
    description: "Teknoloji konferansı için modern ve dijital poster tasarımı. Gradient ve geometric pattern kullanımı.",
    image: "https://images.unsplash.com/photo-1540575467063-178a50c2df87?w=800&q=80",
    year: "2024",
    client: "Dijital Zirve",
    featured: false,
    bgColor: "#1a1a1a"
  },
  {
    id: 10,
    title: "Bloom Çiçekçi Logo Tasarımı",
    category: "Logo Tasarım",
    tags: ["Logo Tasarım"],
    description: "Çiçekçi için zarif ve organik logo tasarımı. El yapımı hissi veren detaylar ve soft renkler.",
    image: "https://images.unsplash.com/photo-1487070183336-b863922373d4?w=800&q=80",
    year: "2023",
    client: "Bloom Flowers",
    featured: false,
    bgColor: "#0a0a0a"
  },
  {
    id: 11,
    title: "Sahil Otel Sosyal Medya Paketi",
    category: "Sosyal Medya Tasarımları",
    tags: ["Sosyal Medya Tasarımları"],
    description: "Butik otel için yaz temalı sosyal medya içerik paketi. Aydınlık ve davetkar görsel dil.",
    image: "https://images.unsplash.com/photo-1582719478250-c89cae4dc85b?w=800&q=80",
    year: "2024",
    client: "Sahil Otel",
    featured: false,
    bgColor: "#1a1a1a"
  },
  {
    id: 12,
    title: "Artisan Fırın Menü Dizaynı",
    category: "Menü / Baskı Tasarımları",
    tags: ["Menü / Baskı Tasarımları"],
    description: "El yapımı ekmek fırını için rustik ve authentic menü tasarımı. Craft paper üzerine baskı odaklı.",
    image: "https://images.unsplash.com/photo-1555507036-ab1f4038808a?w=800&q=80",
    year: "2023",
    client: "Artisan Fırın",
    featured: false,
    bgColor: "#0a0a0a"
  }
];

export const categories = [
  "Tümü",
  "Logo Tasarım",
  "Kurumsal Kimlik",
  "Sosyal Medya Tasarımları",
  "Afiş / Poster Tasarım",
  "Menü / Baskı Tasarımları"
];

export const services = [
  {
    id: 1,
    title: "Logo Tasarım",
    description: "Markanızın DNA'sını yansıtan, özgün ve akılda kalıcı logo tasarımları.",
    icon: "Palette"
  },
  {
    id: 2,
    title: "Kurumsal Kimlik",
    description: "Logo'dan kartvizite, tüm marka dokunuş noktalarınız için tutarlı kimlik sistemleri.",
    icon: "Layers"
  },
  {
    id: 3,
    title: "Sosyal Medya Tasarım",
    description: "Dikkat çeken, markanıza özgü sosyal medya görselleri ve içerik paketleri.",
    icon: "Instagram"
  },
  {
    id: 4,
    title: "Baskı Tasarımları",
    description: "Broşür, katalog, menü ve tüm baskı materyalleriniz için profesyonel tasarımlar.",
    icon: "FileText"
  },
  {
    id: 5,
    title: "Ambalaj Tasarımı",
    description: "Ürününüzü öne çıkaran, satın alma kararını etkileyen ambalaj çözümleri.",
    icon: "Package"
  },
  {
    id: 6,
    title: "Marka Danışmanlığı",
    description: "Markanızın doğru konumlanması ve hedef kitlenize ulaşması için strateji desteği.",
    icon: "Target"
  }
];

export const stats = [
  { value: "50+", label: "Tamamlanan Proje" },
  { value: "30+", label: "Mutlu Müşteri" },
  { value: "5+", label: "Yıllık Deneyim" },
  { value: "100%", label: "Müşteri Memnuniyeti" }
];

export const testimonials = [
  {
    id: 1,
    name: "Mehmet Yılmaz",
    company: "Kafe Zero",
    text: "ADK Creative ile çalışmak harikaydı. Markamızın kimliğini mükemmel şekilde yansıtan bir tasarım ortaya çıkardılar.",
    avatar: "https://i.pravatar.cc/150?img=12"
  },
  {
    id: 2,
    name: "Ayşe Demir",
    company: "Organic Market",
    text: "Sosyal medya tasarımlarımız sayesinde etkileşimimiz %200 arttı. Profesyonel ve hızlı bir ekip.",
    avatar: "https://i.pravatar.cc/150?img=5"
  },
  {
    id: 3,
    name: "Can Öztürk",
    company: "TechStart",
    text: "Logo tasarımımız startup dünyasında çok beğenildi. Modern ve yenilikçi yaklaşımları için teşekkürler!",
    avatar: "https://i.pravatar.cc/150?img=33"
  }
];
